<label class="fieldset-label select-none">
  <input
    [checked]="checked()"
    (change)="checked.set($any($event.target).checked)"
    type="checkbox"
    class="checkbox rounded"
    [ngClass]="[colorClasses[color()].checkbox, colorClasses[color()].border, sizeClasses[size()]]" />
  @if (label(); as label) {
    <p class="text-base-content font-normal text-sm">{{ label }}</p>
  }
</label>
